// TO CREATE FLN ACTIVITY TOPIC
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import GamepadIcon from "@mui/icons-material/Gamepad";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import { red, blue, green, purple, orange } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Typography,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { usertype_change, language_change, section_change } from "./FaqSlice";
import {
  getFaqQuizThunk,
  deleteFaqQuizThunk,
  updateFaqQuizThunk,
  save_azure_file,
} from "./FaqThunk";
import { getFaqSectionThunk } from "../FaqSection/FaqSectionThunk";
import FaqTemplete from "../quiz_template/FaqTemplete";
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";

const FaqPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { usertype, language, sections } = useSelector(
    (state) => state.FaqSlice
  );

  console.log(
    "usertype",
    usertype,
    language,
    sections?.sectionId,
    sections?.sectionName
  );

  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];

  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [faqList, setFaqList] = useState([]);
  console.log("faqList", faqList);
  const [updatedFaqList, setUpdatedFaqList] = useState([]);
  const [videoFile, setVideoFile] = useState(null);
  console.log("videoFileeeee", videoFile, answer);
  const [videoPreview, setVideoPreview] = useState("");
  const [sectionList, setSectionList] = useState([]);
  const [action, setAction] = useState("");
  const [params, setParams] = useState(null);
  const [sectionId, setSectionId] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [answerType, setAnswerType] = useState("");
  const [alertOnQuestion, setAlertOnQuestion] = useState(false);
  const [questionOrder, setQuestionOrder] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [questionMedia, setQuestionMedia] = useState("");
  const [instructions, setInstructions] = useState("");
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  const [correctOption, setCorrectOption] = useState("");
  const [optionType, setOptionType] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isQuestionAdded, setIsQuestionAdded] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [youTubeLink, setYouTubeLink] = useState("");
  console.log("youtubeLink", youTubeLink);

  const inputFileRef = useRef();

  let quizData = faqList?.quizData;
  if (!Array.isArray(faqList?.quizData)) {
    quizData = [];
  }

  const getMaxQuestionOrder = () => {
    const maxOrder =
      quizData?.length > 0 &&
      quizData?.reduce((max, faq) => {
        return faq.questionOrder > max ? faq.questionOrder : max;
      }, 0);
    return maxOrder + 1; // Increment by 1 for the new question order
  };

  // const sortedQuizData = faqList[0]
  //   ?.slice()
  //   ?.sort((a, b) => a.questionOrder - b.questionOrder);
  // const quizData = [];

  const navigate_to = () => {
    navigate("/faqsection");
    setFaqList([]);
    setSectionId("");
    setSectionName("");
  };

  const handleOpenModal = () => {
    const maxOrder = getMaxQuestionOrder();
    setQuestionOrder(maxOrder);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setQuestion("");
    setAnswerType("");
    setAnswer("");
    setVideoPreview("");
  };

  const handleAnswerTypeSelect = (value) => {
    if (!question.trim() && value !== "") {
      // Show alert if no question is typed and an answer type is selected
      setAlertOnQuestion(true);
      return;
    }
    setAnswerType(value);
    if (value === "videoInput") {
      setAnswer(""); // Clear the text answer field
      setVideoPreview(""); // Clear any existing video preview
      setVideoFile(null); // Clear the previous video file
    }
  };

  const handleVideoUpload = async (event) => {
    setVideoPreview("");
    setIsLoading(true);
    const file = event.target.files[0];
    const fileSizeLimit = 4 * 1024 * 1024; // 4 MB limit
    // if (file && file.size > fileSizeLimit) {
    //   alert("File is too big. Maximum allowed size is 4MB.");
    //   event.target.value = "";
    //   return;
    // }
    const reader = new FileReader();
    reader.onloadend = () => {
      setVideoFile(file); // Store the uploaded video file
      const isVideo = updateData?.answerType === "videoInput"; // Check if answer type is video
      const prevVideoPreview = isVideo ? updateExtra?.answer : ""; // Store previous video preview URL
      setVideoPreview(reader?.result || prevVideoPreview);
    };
    reader.readAsDataURL(file);
    const formData = new FormData();
    formData.append("file", file);
    setIsLoading(false);
    setSelectedFileName(file.name);

    // fetch(`https://thinkzone.in.net/thinkzone/uploadFile/${file.name}`, {
    //   method: "POST",
    //   body: formData,
    //   // Add any necessary headers like authorization, content-type, etc.
    // })
    //   .then((response) => {
    //     if (response.ok) {
    //       console.log("response", response);
    //       return response.json(); // Parse the response body as JSON
    //     } else {
    //       throw new Error("File upload failed");
    //     }
    //   })
    //   .then((data) => {
    //     console.log("data", data);
    //     setAnswer(data.url); // Set the answer with the video URL
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     console.error("Error uploading file:", error);
    //     setIsLoading(false);
    //     throw error;
    //   });
  };

  const handleDeleteFile = async (url) => {
    console.log("bolbname", url);
    if (!url) {
      // Handle scenario where url is not available
      return;
    }

    try {
      await deleteFileFromAzure(url);
      setVideoPreview("");
      // Additional logic after successful deletion (e.g., update UI, state, etc.)
    } catch (error) {
      console.error("Error deleting file:", error);
      // Handle error scenarios during deletion
    }
    setVideoPreview(""); // Clear the video preview state
    setUpdateData((prevData) => ({ ...prevData, answer: "" }));
  };
  const deleteFileFromAzure = async (url) => {
    setIsLoading(true);

    // fetch(`https://thinkzone.in.net/thinkzone/uploadFile/${blobName}`, {
    //   method: "POST",
    //   body: formData,
    //   // Add any necessary headers like authorization, content-type, etc.
    // })
    //   .then((response) => {
    //     if (response.ok) {
    //       console.log("response", response);
    //       return response.json(); // Parse the response body as JSON
    //     } else {
    //       throw new Error("File upload failed");
    //     }
    //   })
    //   .then((data) => {
    //     console.log("data", data);
    //     setAnswer(data.url); // Set the answer with the video URL
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     console.error("Error uploading file:", error);
    //     setIsLoading(false);
    //     throw error;
    //   });
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  // ------------ dropdowns on change ----------------
  const language_select_onchange = (event) => {
    dispatch(language_change(event?.target?.value));
    dispatch(usertype_change(""));
    // dispatch(section_change({}));
    sectionId("");
    sectionName("");
  };

  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event?.target?.value));
    // dispatch(section_change({}));
    sectionId("");
    sectionName("");
    setIsLoading(true);
    const params = { usertype: event?.target?.value };
    dispatch(getFaqSectionThunk(params))
      .then((response) => {
        setSectionList(response?.payload);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const section_select_onchange = (event, value) => {
    if (event?.target?.value === "") {
      setSectionId("");
      setFaqList([]);
      return;
    }
    // dispatch(
    //   section_change({
    //     sectionId: event?.target?.value,
    //     sectionName: value?.props?.children,
    //   })
    // );
    setSectionId(event?.target?.value);
    setSectionName(value?.props?.children);

    const params = { usertype, sectionId: event.target.value };
    setIsLoading(true);
    dispatch(getFaqQuizThunk(params))
      .then((response) => {
        setFaqList(response?.payload);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    const params = { usertype };
    dispatch(getFaqSectionThunk(params))
      .then((response) => {
        setSectionList(response?.payload);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }, []);
  //   const videoPreview = videoFile ? URL.createObjectURL(videoFile) : null;

  const handleAddFAQ = async () => {
    if (answerType === "videoInput" && !videoFile) {
      // If the answer type is video and no file is chosen
      toast.error("Please select a video file.");
      return;
    } else if (answerType === "text" && !answer.trim()) {
      toast.error("Please provide an answer in text.");
      return;
    } else if (answerType === "videoInput" && videoFile) {
      UploadFileToAzureDB(videoFile, selectedFileName);
    }

    const newFAQ = {
      questionOrder,
      questionId: new Date().getTime(),
      question,
      questionMedia,
      instructions,
      answerType,
      optionA,
      optionB,
      optionC,
      optionD,
      correctOption,
      optionType,
      selectedOption,
      answer:
        answerType === "videoInput"
          ? selectedFileName
          : answerType === "youtube"
          ? youTubeLink.split("/")[3].replace("watch?v=", "").slice(0, 11)
          : answer,
    };

    console.log("body sent----------------------->", newFAQ);

    // if (answerType === "video" && videoFile) {
    //   try {
    //     const videoURL = await uploadFileAndGetURL(videoFile);
    //     newFAQ.answer = videoURL;
    //   } catch (error) {
    //     console.error("Failed to upload video:", error);
    //     // Handle error scenario when video upload fails
    //   }
    // }

    // Create a copy of the existing FAQ list and add the new FAQ
    const updatedQuizData = [...(quizData || []), newFAQ];

    const dataToUpdate = {
      sectionId,
      sectionName,
      quizData: updatedQuizData, // Update the quizData with the new list
    };

    // Dispatch action to update the FAQ quiz data
    setIsLoading(true);
    dispatch(updateFaqQuizThunk(dataToUpdate))
      .then((res) => {
        if (res?.payload?.msg == "updated success") {
          toast.success("Changes made successfully", {
            style: {
              backgroundColor: "green",
              color: "white",
              borderRadius: "30px",
            },
          });
          setVideoPreview("");
          setIsModalOpen(false);
          setIsLoading(true);
          const params = { usertype, sectionId: sectionId };
          dispatch(getFaqQuizThunk(params))
            .then((response) => {
              setFaqList(response?.payload);
              setIsLoading(false);
              setVideoFile(null);
              setSelectedFileName("");
            })
            .catch((error) => {
              console.error("Error:", error);
              setIsLoading(false);
            });
        } else {
          toast.error("question upload failed");
          setIsLoading(false);
          setIsModalOpen(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 413) {
          toast.error("The file is too large to upload");
        } else if (error.response && error.response.status === 500) {
          toast.error("something went wrong");
        } else if (error.response && error.response.status === 504) {
          toast.error("something went wrong, please try after some time");
        } else {
          console.error("Error:", error);
          toast.error("question upload failed");
          // Handle error scenarios if the update fails
        }
      });
    setIsModalOpen(false);
    setIsQuestionAdded(true);
    setQuestion("");
    setAnswerType("");
    setAnswer("");
    setVideoPreview("");
  };

  const [showUpdate, setShowUpdate] = useState(false);
  const [updateData, setUpdateData] = useState({
    sectionId,
    sectionName,
    quizData: [
      {
        questionOrder: questionOrder,
        questionId: new Date().getTime(),
        question,
        questionMedia,
        instructions,
        answerType,
        optionA,
        optionB,
        optionC,
        optionD,
        correctOption,
        optionType,
        selectedOption,
        answer,
      },
    ],
  });
  //console.log("updateData-->", updateData);

  const deleteFileForUpdate = (item) => {
    deleteFileFromDB(item.answer);
    setUpdateData({ ...updateData, answer: "" });
    setVideoPreview("");
  };

  const [updateExtra, setUpdateExtra] = useState([]);
  const handleShowUpdate = (faq) => {
    console.log("faqh", faq);
    setUpdateExtra(faq);
    setUpdateData({
      sectionId: faq?.sectionId,
      questionId: faq?.questionId,
      question: faq?.question,
      instructions: faq?.instructions,
      answer: faq?.answer,
      questionOrder: faq?.questionOrder,
      answerType: faq?.answerType,
      optionA: faq?.optionA,
      optionB: faq?.optionB,
      optionC: faq?.optionC,
      optionD: faq?.optionD,
      correctOption: faq?.correctOption,
      optionType: faq?.optionType,
      selectedOption: faq?.selectedOption,
      questionMedia: faq?.questionMedia,
    });

    const isVideo = faq?.answerType === "videoInput"; // Check if answer type is video
    const prevVideoPreview = isVideo ? faq?.answer : ""; // Store previous video preview URL
    setVideoPreview(prevVideoPreview);
    setShowUpdate(true);
  };

  // const handleUpdateFaq = async () => {
  //   UploadFileToAzureDB(videoFile, selectedFileName);

  //   const updatedQuizData = quizData.map((faq) => {
  //     if (faq?.questionId === updateExtra?.questionId) {
  //       return {
  //         ...faq,
  //         questionOrder: updateData?.questionOrder.toString(),
  //         question: updateData?.question,
  //         instructions: updateData?.instructions,
  //         answer: videoFile
  //           ? selectedFileName
  //           : updateData.answer.split("/")[
  //               updateData.answer.split("/").length - 1
  //             ],
  //         questionMedia: updateData.questionMedia,
  //         answerType: updateData?.answerType,
  //         optionA: updateData?.optionA,
  //         optionB: updateData?.optionB,
  //         optionC: updateData?.optionC,
  //         optionD: updateData?.optionD,
  //         correctOption: updateData?.correctOption,
  //         optionType: updateData?.optionType,
  //         selectedOption: updateData?.selectedOption,
  //       };
  //     }
  //     return faq;
  //   });

  //   // if (updateData?.answerType === "video" && videoFile) {
  //   //   try {
  //   //     const videoURL = await uploadFileAndGetURL(videoFile);
  //   //     setUpdateData({
  //   //       ...updateData,
  //   //       answer: videoURL,
  //   //     });
  //   //   } catch (error) {
  //   //     console.error("Failed to upload video:", error);
  //   //     // Handle error scenario when video upload fails
  //   //   }
  //   // }

  //   const dataToUpdate = {
  //     sectionId,
  //     sectionName,
  //     quizData: updatedQuizData,
  //   };
  //   setIsLoading(true);
  //   dispatch(updateFaqQuizThunk(dataToUpdate))
  //     .then((response) => {
  //       console.log("Updated FAQ:", response);
  //       if (response?.payload?.msg == "updated success") {
  //         setIsModalOpen(false);
  //         setIsLoading(true);
  //         const params = { usertype, sectionId: sectionId };
  //         dispatch(getFaqQuizThunk(params))
  //           .then((response) => {
  //             setFaqList(response?.payload);
  //             setIsLoading(false);
  //             setVideoPreview("");
  //             setVideoFile(null);
  //           })
  //           .catch((error) => {
  //             if (error.response && error.response.status === 413) {
  //               toast.error("The file is too large to upload");
  //               console.error("The error is:", error);
  //               setIsLoading(false);
  //             } else {
  //               console.error("Error:", error);
  //               setIsLoading(false);
  //             }
  //           });
  //         toast.success("Changes made successfully");
  //       } else {
  //         toast.error("question upload failed");
  //         setIsLoading(false);
  //         setIsModalOpen(false);
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status === 413) {
  //         toast.error("The file is too large to upload");
  //       } else {
  //         console.error("Error:", error);
  //         // Handle error scenarios if the update fails
  //       }
  //     });
  //   setShowUpdate(false);
  //   setQuestion("");
  //   setAnswerType("");
  //   setAnswer("");
  //   setVideoPreview("");
  // };
  const handleUpdateFaq = async () => {
    UploadFileToAzureDB(videoFile, selectedFileName);

    const updatedQuizData = quizData.map((faq) => {
      if (faq?.questionId === updateExtra?.questionId) {
        return {
          ...faq,
          questionOrder: updateData?.questionOrder.toString(),
          question: updateData?.question,
          instructions: updateData?.instructions,
          answer: videoFile
            ? selectedFileName
            : updateData.answer.split("/")[
                updateData.answer.split("/").length - 1
              ],
          questionMedia: updateData.questionMedia,
          answerType: updateData?.answerType,
          optionA: updateData?.optionA,
          optionB: updateData?.optionB,
          optionC: updateData?.optionC,
          optionD: updateData?.optionD,
          correctOption: updateData?.correctOption,
          optionType: updateData?.optionType,
          selectedOption: updateData?.selectedOption,
        };
      }
      return faq;
    });

    const dataToUpdate = {
      sectionId,
      sectionName,
      quizData: updatedQuizData,
    };
    setIsLoading(true);
    dispatch(updateFaqQuizThunk(dataToUpdate))
      .then((response) => {
        console.log("Updated FAQ:", response);
        if (response?.payload?.msg == "updated success") {
          setIsModalOpen(false);
          setIsLoading(true);
          const params = { usertype, sectionId: sectionId };
          dispatch(getFaqQuizThunk(params))
            .then((response) => {
              setFaqList(response?.payload);
              setIsLoading(false);
              setVideoPreview("");
              setVideoFile(null);
            })
            .catch((error) => {
              if (error.response && error.response.status === 413) {
                toast.error("The file is too large to upload");
                console.error("The error is:", error);
                setIsLoading(false);
              } else if (error.response && error.response.status === 504) {
                toast.error("Gateway Timeout. Please try again later.");
                setIsLoading(false);
              } else {
                console.error("Error:", error);
                setIsLoading(false);
              }
            });
          toast.success("Changes made successfully", {
            style: {
              backgroundColor: "green",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error("Question upload failed");
          setIsLoading(false);
          setIsModalOpen(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setIsModalOpen(false);
        if (error.response) {
          if (error.response.status === 413) {
            toast.error("The file is too large to upload");
          } else if (error.response.status === 500) {
            toast.error("Internal Server Error. Please try again later.");
          } else if (error.response.status === 504) {
            toast.error("Gateway Timeout. Please try again later.");
          } else {
            console.error("Error:", error);
          }
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
    setShowUpdate(false);
    setQuestion("");
    setAnswerType("");
    setAnswer("");
    setVideoPreview("");
  };

  // const handleDeleteFAQ = (index) => {
  //   console.log(
  //     "answer sent to the deletion-------------------------->",
  //     index
  //   );
  //   if (index.answer) {
  //     deleteFileFromDB(index.answer);
  //   }

  //   const updatedQuizData = [...quizData];
  //   updatedQuizData.splice(index, 1); // Remove the question at the specified index

  //   const dataToUpdate = {
  //     sectionId,
  //     sectionName,
  //     quizData: updatedQuizData,
  //   };

  //   setIsLoading(true);
  //   dispatch(updateFaqQuizThunk(dataToUpdate))
  //     .then((response) => {
  //       console.log("Question deleted:", response);
  //       if (response?.payload?.msg === "updated success") {
  //         setIsLoading(true);
  //         const params = { usertype, sectionId };
  //         dispatch(getFaqQuizThunk(params))
  //           .then((response) => {
  //             setFaqList(response?.payload);
  //             setIsLoading(false);
  //           })
  //           .catch((error) => {
  //             console.error("Error:", error);
  //             setIsLoading(false);
  //           });
  //         toast.success("Question deleted successfully", {
  //           style: {
  //             backgroundColor: "green",
  //             color: "white",
  //             borderRadius: "30px",
  //           },
  //         });
  //       } else {
  //         toast.error("Failed to delete question");
  //         setIsLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //       // Handle error scenarios if deleting the question fails
  //     });
  // };
  const handleDeleteFAQ = (index) => {
    console.log(
      "answer sent to the deletion-------------------------->",
      index
    );
    if (index.answer) {
      deleteFileFromDB(index.answer);
    }

    const updatedQuizData = [...quizData];
    updatedQuizData.splice(index, 1); // Remove the question at the specified index

    const dataToUpdate = {
      sectionId,
      sectionName,
      quizData: updatedQuizData,
    };

    setIsLoading(true);
    dispatch(updateFaqQuizThunk(dataToUpdate))
      .then((response) => {
        console.log("Question deleted:", response);
        if (response?.payload?.msg === "updated success") {
          setIsLoading(true);
          const params = { usertype, sectionId };
          dispatch(getFaqQuizThunk(params))
            .then((response) => {
              setFaqList(response?.payload);
              setIsLoading(false);
            })
            .catch((error) => {
              console.error("Error:", error);
              if (error.response && error.response.status === 504) {
                toast.error("Gateway Timeout. Please try again later.");
              } else if (error.response && error.response.status === 500) {
                toast.error("Internal Server Error. Please try again later.");
              } else {
                toast.error("Something went wrong. Please try again.");
              }
              setIsLoading(false);
            });
          toast.success("Question deleted successfully", {
            style: {
              backgroundColor: "green",
              color: "white",
              borderRadius: "30px",
            },
          });
        } else {
          toast.error("Failed to delete question");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
        if (error.response) {
          if (error.response.status === 500) {
            toast.error("Internal Server Error. Please try again later.");
          } else if (error.response.status === 504) {
            toast.error("Gateway Timeout. Please try again later.");
          } else {
            toast.error("Something went wrong. Please try again.");
          }
        } else {
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  console.log("answer----------------------->", answer);
  // console.log("updateData---------------------->", updateData);
  // console.log("videoFile-------------------------->", videoFile);
  // console.log("fileName------------------------->", selectedFileName);
  // console.log("answer------------------------->", videoPreview);
  // console.log("quizData----------------------------->", quizData);

  return (
    <>
      <MuiHeader header="Faq" />
      <div style={{ flex: 1, flexDirection: "row" }}>
        <Grid container spacing={2} justifyContent="flex-start">
          <Grid item>
            <FormControl
              sx={{ width: "100%" }}
              style={{ width: "130px" }}
              size="small"
            >
              <InputLabel id="language-select-label">Language</InputLabel>
              <Select
                labelId="language-select-label"
                id="language-select"
                value={language}
                label="Language"
                onChange={language_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language_select_option_list.map((option) => (
                  <MenuItem key={option?.value} value={option?.value}>
                    {option?.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl
              sx={{ width: "100%" }}
              style={{ width: "130px" }}
              size="small"
            >
              <InputLabel id="usertype-select-label">User Type</InputLabel>
              <Select
                labelId="usertype-select-label"
                id="usertype-select"
                value={usertype}
                label="User Type"
                onChange={usertype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype_select_option_list.map((option) => (
                  <MenuItem key={option?.value} value={option?.value}>
                    {option?.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl
              sx={{ width: "100%" }}
              style={{ width: "130px" }}
              size="small"
            >
              <InputLabel id="demo-select-small">Section</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={sectionId}
                label="section"
                onChange={section_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {sectionList && sectionList?.length > 0
                  ? sectionList.map((option) => (
                      <MenuItem
                        key={option?.sectionId}
                        value={option?.sectionId}
                      >
                        {option?.sectionName}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
          {sectionId && sectionId?.length > 0 && sectionId !== "" ? (
            <Grid item>
              <Button variant="contained" onClick={() => handleOpenModal()}>
                ADD FAQ QUESTIONS
              </Button>
            </Grid>
          ) : null}

          <Grid item xs={12}>
            <Button
              onClick={navigate_to}
              variant="contained"
              style={{
                width: "130px",
                backgroundColor: "blue",
              }}
            >
              <GamepadIcon
                style={{
                  color: "orange",
                }}
              ></GamepadIcon>
              <b style={{ color: "white" }}>Section</b>
            </Button>
          </Grid>
        </Grid>
      </div>

      {/* Modal */}
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="faq-modal"
        aria-describedby="faq-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%", // Adjust the width to fit more content
            maxWidth: "800px", // Set a maximum width if needed
            bgcolor: "background.paper",
            border: "2px solid #000",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: "99vh", // Set a maximum height for the modal content
            overflow: "auto", // Allow content to be scrollable
          }}
        >
          <h2 id="faq-modal">ADD FAQ</h2>
          <TextField
            type="number"
            label="Question Order"
            value={questionOrder}
            onChange={(e) => {
              const value = e.target.value;
              if (!isNaN(value) && parseInt(value) > 0) {
                setQuestionOrder(parseInt(value));
              }
            }}
            fullWidth
            margin="normal"
            disabled
          />

          <TextField
            label="Question"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            fullWidth
            multiline
            margin="normal"
            rows={4}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="answer-type-select-label">Answer-Type</InputLabel>
            <Select
              labelId="answer-type-select-label"
              id="answer-type-select"
              value={answerType}
              // onChange={(e) => setAnswerType(e.target.value)}
              onChange={(e) => handleAnswerTypeSelect(e.target.value)}
              disabled={!question.trim()}
            >
              <MenuItem value="">Select Answer Type</MenuItem>
              <MenuItem value="text">Text</MenuItem>
              {/* <MenuItem value="videoInput">Video</MenuItem> */}
              <MenuItem value="youtube">Youtube</MenuItem>
            </Select>
          </FormControl>
          {answerType === "text" && (
            <TextField
              label="Answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              fullWidth
              multiline
              rows={4}
              margin="normal"
            />
          )}
          {answerType === "videoInput" && (
            <>
              <FormControl fullWidth margin="normal">
                <input
                  type="file"
                  accept="video/*"
                  onChange={handleVideoUpload}
                />
              </FormControl>
              {isLoading ? (
                // Show loader while isLoading is true
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <CircularProgress /> {/* MUI Circular Progress for loader */}
                </div>
              ) : (
                videoPreview && (
                  <div style={{ position: "relative" }}>
                    <IconButton
                      onClick={() => handleDeleteFile(videoFile?.name)}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <video
                      width="500"
                      height="240"
                      controls
                      className={classes.video}
                      style={{
                        marginTop: "10px",
                        objectFit: "contain",
                      }}
                    >
                      <source src={videoPreview} type="video/mp4" />
                      Your browser does not support HTML video.
                    </video>
                  </div>
                )
              )}
            </>
          )}
          {answerType === "youtube" && (
            <>
              <TextField
                id="linkUrl"
                label="URL"
                name="linkUrl"
                size="small"
                autoComplete="url"
                margin="normal"
                required
                fullWidth
                value={youTubeLink}
                onChange={(e) => {
                  const url = e.target.value;
                  if (url.startsWith("https://www.youtube.com/watch?v=")) {
                    const videoId = url.split("v=")[1].slice(0, 11);
                    console.log(
                      "videoId----------------------------<>",
                      videoId
                    );
                    setYouTubeLink(`https://youtu.be/${videoId}`);
                  } else {
                    setYouTubeLink(url);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              {youTubeLink && youTubeLink.startsWith("https://youtu.be/") && (
                <iframe
                  title="YouTube Video"
                  width="300"
                  height="195"
                  src={`https://www.youtube.com/embed/${youTubeLink
                    .split("/")[3]
                    .slice(0, 11)}`}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              )}
            </>
          )}
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleCloseModal()}
                style={{ width: "100px" }} // Adjust the width as needed
              >
                Cancel
              </Button>
            </Grid>
            {answerType ? (
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleAddFAQ}
                  style={{ width: "100px" }} // Adjust the width as needed
                >
                  Add FAQ
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </Box>
      </Modal>

      {/* Show List */}
      {isLoading ? (
        // Show loader while isLoading is true
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <CircularProgress /> {/* MUI Circular Progress for loader */}
        </div>
      ) : (
        <Box
          sx={{
            display: "flex",
            marginTop: 1,
            flexDirection: "column", // Arrange boxes in a column
          }}
        >
          {isLoading ? (
            // Show loader while isLoading is true
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <CircularProgress />
            </div>
          ) : quizData && quizData?.length > 0 ? (
            quizData?.map((faq, index) => (
              <Grid container spacing={3} key={index} sx={{ width: "100%" }}>
                <Grid item xs={12}>
                  <Box className={classes.boxContainer} sx={{ width: "100%" }}>
                    <Typography variant="h6" gutterBottom>
                      <strong>Question:</strong> {faq?.questionOrder}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <strong>Question:</strong> {faq?.question}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <strong>Answer:</strong>{" "}
                      {faq?.answerType === "videoInput" ? (
                        <video
                          controls
                          className={classes.video}
                          style={{
                            width: "50%",
                            height: "auto",
                            objectFit: "contain",
                          }}
                        >
                          <source
                            src={`https://storage.googleapis.com/tz-bucket-0/${faq?.answer}`}
                            type="video/mp4"
                          />
                          Your browser does not support HTML video.
                        </video>
                      ) : faq.answerType === "youtube" ? (
                        <iframe
                          title="YouTube Video"
                          width="300"
                          height="195"
                          src={`https://www.youtube.com/embed/${faq?.answer}`}
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        faq?.answer
                      )}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        // marginTop: 1, // Adjust the top margin for space between content
                        "& > button": {
                          marginLeft: 1, // Adjust the left margin between buttons
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        color="error"
                        // onClick={() => handleDeleteFAQ(index)}
                        onClick={() => handleDeleteFAQ(index)}
                      >
                        Delete
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleShowUpdate(faq)}
                      >
                        Edit
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            ))
          ) : (
            ""
          )}
        </Box>
      )}

      <Modal
        open={showUpdate}
        onClose={handleCloseUpdate}
        aria-labelledby="faq-modal"
        aria-describedby="faq-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%", // Adjust the width to fit more content
            maxWidth: "800px", // Set a maximum width if needed
            bgcolor: "background.paper",
            border: "2px solid #000",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: "99vh", // Set a maximum height for the modal content
            overflow: "auto", // Allow content to be scrollable
          }}
        >
          <h2 id="faq-modal">Update FAQ</h2>
          <TextField
            type="number"
            label="Question Order"
            value={updateData?.questionOrder}
            onChange={(e) =>
              setUpdateData({
                ...updateData,
                questionOrder: e.target.value,
              })
            }
            fullWidth
            margin="normal"
            disabled
          />

          <TextField
            label="Question"
            value={updateData?.question}
            onChange={(e) =>
              setUpdateData({
                ...updateData,
                question: e.target.value,
              })
            }
            fullWidth
            multiline
            margin="normal"
            rows={4}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="answer-type-select-label">Answer-Type</InputLabel>
            <Select
              labelId="answer-type-select-label"
              id="answer-type-select"
              value={updateData?.answerType}
              onChange={(e) =>
                setUpdateData({
                  ...updateData,
                  answerType: e.target.value,
                })
              }
              // disabled={!question.trim()}
            >
              <MenuItem value="">Select Answer Type</MenuItem>
              <MenuItem value="text">Text</MenuItem>
              {/* <MenuItem value="videoInput">Video</MenuItem> */}
              <MenuItem value="youtube">Youtube</MenuItem>
            </Select>
          </FormControl>
          {updateData?.answerType === "text" && (
            <TextField
              label="Answer"
              value={updateData?.answer}
              onChange={(e) =>
                setUpdateData({
                  ...updateData,
                  answer: e.target.value,
                })
              }
              fullWidth
              multiline
              rows={4}
              margin="normal"
            />
          )}

          {updateData?.answerType === "videoInput" && (
            <>
              <FormControl
                fullWidth
                margin="normal"
                style={{ position: "relative" }}
              >
                <input
                  type="file"
                  accept="video/*"
                  onChange={handleVideoUpload}
                />
                {updateData?.answerType === "videoInput" &&
                  (updateData?.answer ? (
                    <p>
                      File:{" "}
                      {
                        updateData?.answer.split("/")[
                          updateData?.answer.split("/").length - 1
                        ]
                      }
                    </p>
                  ) : null)}
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  videoPreview && (
                    <div style={{ position: "relative" }}>
                      <IconButton
                        onClick={() => deleteFileForUpdate(updateData)}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                      <video
                        controls
                        style={{
                          width: "50%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      >
                        <source
                          src={`https://storage.googleapis.com/tz-bucket-0/${updateData?.answer}`}
                          type="video/mp4"
                        />
                        Your browser does not support HTML video.
                      </video>
                    </div>
                  )
                )}
              </FormControl>
            </>
          )}
          {updateData?.answerType === "youtube" && (
            <>
              <TextField
                id="linkUrl"
                label="YouTube URL"
                name="linkUrl"
                size="small"
                autoComplete="url"
                margin="normal"
                required
                fullWidth
                value={updateData?.answer || ""}
                onChange={(e) => {
                  const url = e.target.value;
                  let videoId = "";

                  if (url.startsWith("https://www.youtube.com/watch?v=")) {
                    videoId = new URL(url).searchParams.get("v");
                  } else if (url.startsWith("https://youtu.be/")) {
                    videoId = url.split("/").pop();
                  }

                  setUpdateData({
                    ...updateData,
                    answer: `https://youtu.be/${videoId}`,
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              {updateData?.answer.startsWith("https://youtu.be/") && (
                <iframe
                  title="YouTube Video"
                  width="300"
                  height="195"
                  src={`https://www.youtube.com/embed/${updateData.answer
                    .split("/")
                    .pop()}`}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              )}
            </>
          )}
          <Grid container spacing={2} justifyContent="flex-end" marginTop={2}>
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={handleCloseUpdate}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={handleUpdateFaq}>
                Update FAQ
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <ToastContainer />
    </>
  );
};

export default FaqPage;

const useStyles = makeStyles(() => ({
  boxContainer: {
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "16px", // Adjust padding as needed
    marginBottom: "16px", // Adjust margin as needed
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: "border-box", // Include padding in total width
  },
  videoContainer: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    overflow: "hidden",
    borderRadius: "8px",
    marginTop: "16px", // Adjust margin as needed
  },
  video: {
    // position: "absolute",
    top: 0,
    left: 0,
    width: "50%",
    height: "50%",
    borderRadius: "8px",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
